import { createFileRoute, redirect } from '@tanstack/react-router';

/** Paige Scan is under Company, Scanners and devices (Dustin, 2026-10-03); the old address opens it there. */
export const Route = createFileRoute('/t/$tenant/settings/developers/scan')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenant/settings/company/devices',
      hash: 'paige-scan',
      params: { tenant: params.tenant },
      replace: true,
    });
  },
});
